module.exports = __webpack_public_path__ + "img/和合.72b6575c.png";